import api from '@/client/core/api'
import { GetCampaignTweetPostsData, GetCampaignTweetPostsResponse } from '@/typings/campaigns'

import { CampaignTweetPostApiError } from './campaignTweetPostApiError'

export async function getCampaignTweetPosts(campaignId: number): Promise<GetCampaignTweetPostsData> {
  const response = await api.get<GetCampaignTweetPostsResponse>(`/campaigns/${campaignId}/tweet-posts`)

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new CampaignTweetPostApiError(response.error.type, response.error.message, response.error.status)
  }

  if (!response?.data) {
    throw new CampaignTweetPostApiError('INVALID_RESPONSE', '投稿URL取得APIのレスポンス形式が不正です。')
  }

  return response.data
}
